import classNames from "classnames";
import { FormHelperText, FormNumericInput, FormSelect } from "components/form-fields";
import { useValidation } from "hooks/useValidation";
import React, { useEffect } from "react";

export function DocumentTypeAdditionalDetails({ documentType, onChange, onValidationChange, saving, loading }) {
    const isNew = !documentType.id;
    const isBeingDeleted = documentType.dateToBeDeleted;

    const dataRetentionUnits = [
        { id: "Days", name: "Days" },
        { id: "Months", name: "Months" },
        { id: "Years", name: "Years" }
    ]
    
    const [isValid, errors, validate] = useValidation();

    const error = errors["period"] || errors["unit"];

    useEffect(() => {
        const rules = [
            { fieldName: "period", min: 0, max: 1000, required: !!documentType.dataRetention },
            { fieldName: "unit", required: !!documentType.dataRetention }
        ]

        validate(rules, documentType?.dataRetention ?? {});
    }, [documentType]);

    useEffect(() => onValidationChange(isValid), [isValid]);

    const setDataRetentionPeriod = (period) => {
        const dataRetentionClone = period ? { period: period, unit: documentType.dataRetention?.unit } : null;
        const clone = {
            ...documentType,
            dataRetention: dataRetentionClone
        };

        onChange(clone);
    }

    const setDataRetentionUnit = (unit) => {
        const dataRetentionClone =  { period: documentType.dataRetention?.period, unit: unit.id };
        const clone = {
            ...documentType,
            dataRetention: dataRetentionClone
        };

        onChange(clone);
    }

    return (
        <div className={classNames({ "row": !isNew })}>
            <h2>Additional Settings</h2>
            <div className={classNames('form-row field-combination spacer-bottom-small', { 'outer-validation': !!error })}>
                <h4>Data retention period</h4>
                <FormHelperText loading={loading}>If the period is left blank the default retention period for the area will be applied</FormHelperText>
                <FormNumericInput
                    disabled={isBeingDeleted || saving}
                    disabledInput={isBeingDeleted || saving}
                    min={0}
                    max={1000}
                    selectedValue={documentType.dataRetention?.period}
                    onValueChange={setDataRetentionPeriod}
                    loading={loading}
                    placeholder="0"
                ></FormNumericInput>
                <FormSelect
                    disabled={isBeingDeleted || saving}
                    items={dataRetentionUnits}
                    onItemSelect={setDataRetentionUnit}
                    selectedValue={documentType.dataRetention?.unit}
                    loading={loading}
                ></FormSelect>
                <FormHelperText loading={loading} danger={true}>{error}</FormHelperText>
            </div>
        </div>
    );
}